import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\BadgeController::badge
* @see app/Http/Controllers/BadgeController.php:16
* @route '/{edition}/badge'
*/
export const badge = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: badge.url(args, options),
    method: 'get',
})

badge.definition = {
    methods: ["get","head"],
    url: '/{edition}/badge',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BadgeController::badge
* @see app/Http/Controllers/BadgeController.php:16
* @route '/{edition}/badge'
*/
badge.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return badge.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BadgeController::badge
* @see app/Http/Controllers/BadgeController.php:16
* @route '/{edition}/badge'
*/
badge.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: badge.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BadgeController::badge
* @see app/Http/Controllers/BadgeController.php:16
* @route '/{edition}/badge'
*/
badge.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: badge.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\BadgeController::badge
* @see app/Http/Controllers/BadgeController.php:16
* @route '/{edition}/badge'
*/
const badgeForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: badge.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BadgeController::badge
* @see app/Http/Controllers/BadgeController.php:16
* @route '/{edition}/badge'
*/
badgeForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: badge.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BadgeController::badge
* @see app/Http/Controllers/BadgeController.php:16
* @route '/{edition}/badge'
*/
badgeForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: badge.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

badge.form = badgeForm

const BadgeController = { badge }

export default BadgeController